__turbopack_context__.v({
  "animate-slide-in": "styles-module__ezPl9q__animate-slide-in",
  "animate-slide-out": "styles-module__ezPl9q__animate-slide-out",
  "slideIn": "styles-module__ezPl9q__slideIn",
  "slideOut": "styles-module__ezPl9q__slideOut",
});
